import { useState } from 'react';

import { Button } from '../../shared/ui/button';
import { PlusIcon } from '../../shared/ui/icons';
import { isManager } from '../../entities/organization';
import { CredentialsPanel, useCredentials } from '../../features/credentials';
import { SettingsShell } from './settings-shell';
import { useOrganizationSettings } from './use-organization-settings';

export const CredentialsPage = () => {
  const { actor, timeZone } = useOrganizationSettings();
  const credentials = useCredentials();
  const [adding, setAdding] = useState(false);
  const editable = isManager(actor);

  return (
    <SettingsShell
      active="/settings/credentials"
      question="The API keys and logins your flows’ steps sign in to other services with."
      actions={
        editable && (
          <Button
            size="sm"
            disabled={!credentials.connectors.isSuccess}
            onClick={() => setAdding(true)}
          >
            <PlusIcon size={12} /> Add credentials
          </Button>
        )
      }
    >
      <CredentialsPanel
        credentials={credentials}
        editable={editable}
        adding={adding}
        onAddingChange={setAdding}
        timeZone={timeZone}
      />
    </SettingsShell>
  );
};
